// Specificaties bovenaan
(function() {
'use strict';

var interval = setInterval(function() {

var targetContainer =
document.querySelector('.product-custom-liquid #sh-advanced') ||
document.querySelector('.product-custom-liquid #sh-features') ||
document.querySelector('.product-custom-liquid #sh-specs');

var faqItems = document.querySelector('.shopify-section.mount-toggles .faq-items');
var productIcons = document.querySelector('.product-icons-list');
var sidebarOutline = document.querySelector('.product-actions .sidebar-widget.sidebar-widget--outline');

if (targetContainer && faqItems && productIcons && sidebarOutline && sidebarOutline.parentNode) {

targetContainer.appendChild(faqItems);

var firstOpenToggle = faqItems.querySelector('.toggle--faq.opened');

if (firstOpenToggle) {

firstOpenToggle.classList.remove('opened');

var toggleTitle = firstOpenToggle.querySelector('.toggle__title');
var toggleContent = firstOpenToggle.querySelector('.toggle__content');

if (toggleTitle) toggleTitle.setAttribute('aria-expanded', 'false');
if (toggleContent) toggleContent.style.display = 'none';

}

sidebarOutline.parentNode.insertBefore(productIcons, sidebarOutline.nextSibling);

clearInterval(interval);

}

},300);

})();


// Cheering element en levering en retourneren USPs in de cart
(function () {

'use strict';

var STORAGE_KEY = 'sh_delivery_eta';

function getLocale(){

var pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);

if(pathMatch) return pathMatch[1];

var htmlLang = document.documentElement.lang;

if(htmlLang) return htmlLang.substring(0,2);

return 'en';

}

function isMobileDevice(){

if(window.matchMedia){
return window.matchMedia('(max-width:767px)').matches;
}

return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

}

var locale = getLocale();
var isMobile = isMobileDevice();

function shouldRunExperiment(){

if(locale==='nl' && isMobile) return true;
if(locale==='en' && isMobile) return true;
if(locale==='fr' && !isMobile) return true;

return false;

}

var I18N={

nl:{
months:['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'],
delivery:'Levering',
returns:'Binnen 30 dagen <strong>gratis retourneren</strong>',
motivation:'🎉 Lekker bezig! Dit brengt je weer een stap dichter bij je actieve doelen'
},

fr:{
months:['janv','févr','mars','avr','mai','juin','juil','août','sept','oct','nov','déc'],
delivery:'Livraison',
returns:'Retour <strong>gratuit sous 30 jours</strong>',
motivation:'🎉 Bien joué ! Vous êtes un pas de plus vers vos objectifs actifs'
},

en:{
months:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
delivery:'Delivery',
returns:'<strong>Free returns</strong> within 30 days',
motivation:'🎉 Nice work! You’re one step closer to your active goals'
}

};

var t = I18N[locale] || I18N.en;


/* Cheering alleen tonen wanneer experiment actief */

if(shouldRunExperiment()){

var style=document.createElement('style');

style.innerHTML=

'#cart:before{' +
'content:"'+t.motivation.replace(/"/g,'\\"')+'";' +
'display:block;' +
'background:#33ad4624;' +
'padding:10px 15px;' +
'margin-bottom:20px;' +
'border-radius:5px;' +
'color:#000;' +
'}';

document.head.appendChild(style);

}


/* DATE HELPERS */

function pad(n){return n<10?'0'+n:n;}

function formatDate(d){
return pad(d.getDate())+' '+t.months[d.getMonth()];
}

function addBusinessDays(date,days){

var d=new Date(date);
var added=0;

while(added<days){

d.setDate(d.getDate()+1);

var day=d.getDay();

if(day!==0 && day!==6) added++;

}

return d;

}

function fallbackETA(){

return formatDate(addBusinessDays(new Date(),2));

}


/* LOCAL STORAGE */

function saveEta(handle,eta){

var store=JSON.parse(localStorage.getItem(STORAGE_KEY)||'{}');

store[handle]={eta:eta};

localStorage.setItem(STORAGE_KEY,JSON.stringify(store));

}

function readEta(handle){

var store=JSON.parse(localStorage.getItem(STORAGE_KEY)||'{}');

return store[handle] ? store[handle].eta : null;

}


/* PDP ETA OPSLAAN */

var handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);

if(handleMatch){

var handle=handleMatch[1];

var tries=0;

var interval=setInterval(function(){

var el=document.getElementById('sh-delivery-pill-eta');

if(el && el.textContent){

saveEta(handle,el.textContent.trim());

clearInterval(interval);

}

if(++tries>30) clearInterval(interval);

},300);

}


/* CART USP */

if(shouldRunExperiment() && /\/cart/.test(window.location.pathname)){

setInterval(function(){

var items=document.querySelectorAll('.cart-form-item');

for(var i=0;i<items.length;i++){

var item=items[i];

if(item.querySelector('.sh-cart-delivery')) continue;

var link=item.querySelector('.cart-item__title');

if(!link) continue;

var href=link.getAttribute('href');

var match=href && href.match(/\/products\/([^/?#]+)/);

if(!match) continue;

var handle=match[1];

var eta=readEta(handle)||fallbackETA();

var target=item.querySelector('.cart-form-item__price-title-variants');

if(!target) continue;

var el=document.createElement('div');

el.className='sh-cart-delivery';

el.innerHTML=

'<div style="color:#1f8f3a;font-weight:500;font-size:14px;margin-top:6px;">'+
'🚚 <strong>'+t.delivery+':</strong> '+
'<span>'+eta+'</span>'+
'</div>'+

'<div style="color:#1f8f3a;font-weight:500;font-size:13px;">'+
'🔄 '+t.returns+
'</div>';

target.appendChild(el);

}

},1200);

}

})();


(function() {
'use strict';

/* =========================
   ONLY CART (GLOBAL)
   ========================= */

if (window.location.pathname.indexOf('/cart') === -1) {
  return;
}


/* =========================
   LOCALE DETECTIE (STRICT)
   ========================= */

var locale = null;

if (window.location.pathname.indexOf('/fr/') > -1) {
  locale = "fr";

} else if (window.location.pathname.indexOf('/en/') > -1) {
  locale = "en";

} else if (window.location.hostname.indexOf('sportshero.fr') > -1) {
  locale = "fr";

} else if (window.location.hostname.indexOf('sportshero.nl') > -1) {
  locale = "nl";
}
  
/* =========================
   DEVICE DETECTIE
   ========================= */

function isMobileDevice() {
  try {
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  } catch (e) {
    return /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}

var isMobile = isMobileDevice();

/* =========================
   INFLUENCER (FR CART ONLY)
   ========================= */

var isFRCart = (
  window.location.pathname.indexOf('/cart') > -1 &&
  (
    window.location.hostname.indexOf('sportshero.fr') > -1 ||
    window.location.pathname.indexOf('/fr/') > -1
  )
);

if (isFRCart) {

var influencers = {

    "LEQUEENE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/548886944_18404265307142758_6979881200371031153_n.jpg?v=1773259210",
      text:"Excellent choix ! C'est comme ça que j'atteins moi aussi mes 10 000 pas par jour !"
    },

    "ELODIE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/619820871_18097424539906658_8586923352359919895_n.jpg?v=1773259210",
      text:"Excellent choix ! Avec le tapis de course SportsHero, je fais ma méthode 12-5-30 !"
    },

    "CHARLENNE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/497513589_18364384285176287_7220745366739624507_n.jpg?v=1773259210",
      text:"Excellent choix ! Avec le tapis de course SportsHero, j'ai eu le déclic !"
    },

    "MELISSA15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/535154163_18052432418627844_1911566937703366707_n.jpg?v=1773259210",
      text:"Excellent choix ! Je brûle plus de calories grâce à l'inclinaison automatique de 13 %."
    },

    "DIANA15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/375451398_1727345091073809_3955034709608157081_n.jpg?v=1775075543",
      text:"Bon choix ! J'adore l'inclinaison à 13 % et son design compact."
    },

    "CELINE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/celine.jpg?v=1775075580",
      text:"Bon choix ! J'adore l'inclinaison à 13 % et son design compact."
    },

    "ROSE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/rose.jpg?v=1775075661",
      text:"Bon choix ! J'adore l'inclinaison à 13 % et son design compact."
    },

    "MADELINE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/634770253_18093971228069079_1300703812056504327_n.jpg?v=1775075684",
      text:"Excellent choix ! Voici comment j'atteins mon objectif de pas avec mes enfants à la maison."
    },

    "IBTISSEM15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/629316484_18310102636282623_2510423428085957668_n.jpg?v=1775075710",
      text:"Très bon choix ! C'est comme ça que j'ai réussi à perdre 50 kg en seulement 9 mois."
    },

    "LISA15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/616122411_18157213726422068_823932180751394453_n.jpg?v=1775075739",
      text:"Excellent choix : j'adore la qualité, la compacité en plus l'inclinaison de 13 % est fantastique."
    },

    "ALISON15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/407458117_6965370406862729_8010837721811033020_n.jpg?v=1775075762",
      text:"Très bon choix ! C'est comme ça que j'ai réussi à perdre 29 kg en seulement 9 mois."
    },

    "MARINE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/marine.jpg?v=1777402500",
      text:"Excellent choix ! J'utilise le RunningPad quotidiennement."
    },

    "ALEXANDRE15":{
      image:"https://cdn.shopify.com/s/files/1/0718/9741/5944/files/alexandrezama.jpg?v=1777402500",
      text:"Bon choix ! J'adore l'inclinaison à 13 % et son design compact."
    }

  };

  var currentCode = null;

  setInterval(function(){

    var codeElement = document.querySelector('.code-name');
    var block = document.querySelector('.influencer-block');

    if(!codeElement){

      if(block){
        block.remove();
        currentCode = null;
      }

      return;
    }

    var code = codeElement.innerText.trim().toUpperCase();

    if(code === currentCode){
      return;
    }

    currentCode = code;

    if(block){
      block.remove();
    }

    var data = influencers[code];

    if(!data){
      return;
    }

    var newBlock = document.createElement('div');
    newBlock.className = 'influencer-block';

    newBlock.innerHTML =
      '<img src="'+data.image+'">' +
      '<div class="influencer-text">'+data.text+'</div>';

    var container = document.querySelector('.scDiscount__container');

    if(container){
      container.appendChild(newBlock);
    }

  },500);

}

})();

(function () {
  'use strict';

  // Controleer of de pagina Frans is via body class
 if (document.documentElement.classList.contains('frans') === false) return;

  var objectStyle = document.createElement("STYLE");
  var objectCSS = document.createTextNode(
    '.shopify-app-block:has(> .loox-widget) {padding-top: 30px;}' +
    'div#shopify-section-template--24299966267656__media_with_text_overlay_geXAKh {margin-top: 40px;}' +
    'div#sh-delivery {display: none;}'
  );
  objectStyle.appendChild(objectCSS);
  document.head.appendChild(objectStyle);

  function moveReviews() {
    var loox = document.getElementById('looxReviews');
    if (!loox) return;
    var reviewsWrapper = loox.closest('.shopify-section');
    if (!reviewsWrapper) return;
    if (reviewsWrapper.dataset.moved === '1') return;
    var firstContentSection = document.querySelector('.shopify-section .rich-text');
    if (!firstContentSection) return;
    var firstSectionWrapper = firstContentSection.closest('.shopify-section');
    if (!firstSectionWrapper) return;
    reviewsWrapper.dataset.moved = '1';
    var looxFrame = document.getElementById('looxReviewsFrame');
    if (looxFrame) {
      looxFrame.style.setProperty('height', 'auto', 'important');
      looxFrame.removeAttribute('height');
    }
    loox.style.setProperty('height', 'auto', 'important');
    loox.removeAttribute('style');
    reviewsWrapper.style.cssText = 'width:100%;display:block';
    loox.style.cssText = 'width:100%;max-width:100%';
    firstSectionWrapper.parentNode.insertBefore(reviewsWrapper, firstSectionWrapper);
  }

  function moveVideo() {
    var videoSection = document.querySelector('.mount-video-background');
    if (!videoSection) return;
    if (videoSection.dataset.moved === '1') return;
    var reviewsWrapper = document.querySelector('.shopify-section[data-moved="1"]');
    if (!reviewsWrapper) return;
    videoSection.dataset.moved = '1';
    reviewsWrapper.parentNode.insertBefore(videoSection, reviewsWrapper.nextSibling);
  }

  function run() {
    moveReviews();
    moveVideo();
  }

  run();
  setTimeout(run, 500);
  setTimeout(run, 1500);
  setTimeout(run, 3000);
})();
